import PropTypes from 'prop-types';
import { createContext, useState } from 'react';

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {

    AuthProvider.propTypes = {
        children: PropTypes.any
    };
    const [auth, setAuth] = useState({});
    const [persist, setPersist] = useState(JSON.parse(localStorage.getItem('persist')) || true);
    return (
        <AuthContext.Provider
            value={{
                auth, setAuth,
                persist, setPersist
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;